module.exports = __webpack_public_path__ + "static/img/icon slt img (4).dfe31078.svg";